import type { ReactNode } from "react";
import { allDocPages } from "../content";
import DocsLayout from "../layout";
import { CoverageTable, Legend } from "./components";

const rows = [
  { market: "Dow Jones Indices", historical: "Y", delayed: "Y", realTime: "A", level2: "N/A" },
  { market: "S&P Indices", historical: "Y", delayed: "A", realTime: "A", level2: "N/A" },
  { market: "CBOE Indices", historical: "N/A", delayed: "Y", realTime: "A", level2: "N/A" },
  { market: "Nasdaq Indices", historical: "Y", delayed: "Y", realTime: "A", level2: "N/A" },
  { market: "TSX Indices", historical: "Y", delayed: "Y", realTime: "A", level2: "N/A" },
  { market: "Euronext Indices", historical: "Y", delayed: "Y", realTime: "A", level2: "N/A" },
];

export default function IndicesPage(): ReactNode {
  const page = allDocPages.find(p => p.slug === "data-coverage-indices")!;
  return (
    <DocsLayout page={page}>
      <Legend/>
      <CoverageTable rows={rows}/>
    </DocsLayout>
  );
}
